import { Box, BoxProps, ColorOptions, IconButton, ModBox, SpacerNew, Text } from '@jfs/ui-new'
import { useCallback, useEffect } from 'react'
import { FlatList } from 'react-native'
import { TextInputWithCb } from '../../components/TextInputWithCb'
import { convertCamelCaseToString } from '../../utils'

const MerchantDetails = ({
  route: {
    params: { merchantData = JSON.parse(localStorage.getItem('params')) },
  },
  navigation,
}: any) => {
  useEffect(() => {
    merchantData && localStorage.setItem('params', JSON.stringify(merchantData))
  }, [])

  const renderItem = ({ item }: any) => {
    return (
      <Box p={16} f={1}>
        <TextInputWithCb
          label={convertCamelCaseToString(item)}
          value={merchantData[item] ?? ''}
          onChange={() => {}}
          showCheckbox={false}
        />
      </Box>
    )
  }
  const renderMidTidConfigSubItem = ({ item }: any) => {
    return (
      <Box p={16} f={1}>
        <TextInputWithCb
          label={convertCamelCaseToString(Object.keys(item)[0])}
          value={item[Object.keys(item)[0]] ?? ''}
          onChange={() => {}}
          showCheckbox={false}
        />
      </Box>
    )
  }

  const renderMidTidConfig = (item: any) => {
    const formattedData = Object.keys(item).map((key) => {
      return { [key]: item[key] }
    })

    return (
      <Box p={16} borderWidth={1} borderColor={'BORDER_COLOR'} marginVertical={4} borderRadius={8}>
        <FlatList
          data={formattedData}
          renderItem={renderMidTidConfigSubItem}
          numColumns={4}
          keyExtractor={keyExtractor}
        />
      </Box>
    )
  }

  const keyExtractor = (item: any): string => {
    return item?.id
  }

  const onBackPress = useCallback(() => navigation?.navigate('merchantmapping'), [navigation])
  return (
    <Box>
      <Box flexDirection={'row'} alignItems={'center'}>
        <IconButton size={24} color="PRIMARY" id={'ARROW_BACK'} onPress={onBackPress} />
        <SpacerNew direction="horizontal" size={16} />
        <Text
          title={'Entity Merchant Mapping Detail'}
          fontSize={24}
          fontWeight={'600'}
          color={'#5a5c69' as ColorOptions}
        />
      </Box>
      <Box {...styles.container}>
        <FlatList
          data={Object.keys(merchantData).filter((key) => !['ID', 'processingEntityMidTidConfiguration'].includes(key))}
          renderItem={renderItem}
          numColumns={4}
          keyExtractor={keyExtractor}
        />
        <ModBox m={16} show={merchantData?.processingEntityMidTidConfiguration?.length > 0}>
          <Text
            title={'Processing Entity Mid Tid Configuration'}
            fontSize={18}
            fontFamily="jiotype-medium"
            color={'BLACK_75'}
          />
        </ModBox>
        <Box width={'100%'}>{merchantData?.processingEntityMidTidConfiguration?.map(renderMidTidConfig)}</Box>
      </Box>
    </Box>
  )
}

export default MerchantDetails
const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 1,
    height: 1,
  },
  shadowOpacity: 0.1,
  shadowRadius: 4,
  zIndex: 10,
}

const styles = {
  container: {
    ...shadow,
    borderWidth: 1,
    borderTopWidth: 0,
    borderBottomRightRadius: 4,
    borderBottomLeftRadius: 4,
    borderColor: '#e3e6f0' as ColorOptions,

    flexWrap: 'wrap',
    p: 8,
    mt: 32,
  } as BoxProps,
  header: {
    ...shadow,
    marginTop: 16,
    underlayColor: 'WHITE',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 14,
    borderWidth: 1,
    borderRadius: 4,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    borderColor: '#e3e6f0' as ColorOptions,
  } as BoxProps,
}
